import styled from '@emotion/styled';

import { css } from '@emotion/react';
import { boxSizes, mediaQuery, breakpoints, colors } from '@gumtree/ui-library/src/base/theme';

export const sortSelectorCss = (theme) => css`
    width: 190px;
    margin-left: auto;
    padding: 0;

    .react-select__control {
        border-color: ${colors.blade};
        border-radius: ${boxSizes.borderRadius4};
        border-width: 1px;
        &:hover {
            background: ${colors.blue10};
            color: ${theme.palette.secondary.darkContrastText};
            cursor: pointer;
        }
    }
    .react-select__single-value {
        color: ${colors.blade};
    }
    ${mediaQuery.until(breakpoints.medium)} {
        width: 80px;

        .react-select__indicator {
            display: none;
        }

        .react-select__menu {
            width: 180px;
            transform: translateX(-100px);
        }

        .react-select__single-value {
            text-align: center;

            svg {
                margin-right: 6px;
            }
        }
    }

    ${mediaQuery.until(breakpoints.xsmall)} {
        width: 60px;

        .react-select__menu {
            transform: translateX(-120px);
        }
    }
`;

export const Desktop = styled.div`
    display: block;

    ${mediaQuery.until(breakpoints.medium)} {
        display: none;
    }
`;

export const Mobile = styled.div`
    display: none;

    ${mediaQuery.between(breakpoints.xsmall, breakpoints.medium)} {
        display: block;
    }
`;

export const SmallMobile = styled.div`
    display: none;

    ${mediaQuery.until(breakpoints.xsmall)} {
        display: block;
    }
`;
